import script from "./ProfileSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileSettings.vue?vue&type=script&setup=true&lang=js"

import "./ProfileSettings.vue?vue&type=style&index=0&id=2fdbdf54&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fdbdf54"]])

export default __exports__